export const READER = 1;
export const EDITOR = 2;
export const MODERATOR = 3;
export const ADMIN = 4;
export const PRODUCT_OWNER = 5;
